import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
import relativeTime from 'dayjs/plugin/relativeTime';
import dayJs from 'dayjs';
import durationPlugin from 'dayjs/plugin/duration';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayJs.extend(relativeTime);
dayJs.extend(durationPlugin);
dayJs.extend(utc);
dayJs.extend(customParseFormat);

Sentry.init({
  dsn: environment.sentry.dsn,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: environment.sentry.tracesSampleRate,
  tracePropagationTargets: environment.sentry.tracePropagationTargets,
});

if (environment.production) {
  enableProdMode();
}

// eslint-disable-next-line no-console
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));
